// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__El02z","container_video":"styles_container_video__N3YkS","video":"styles_video__honJT","container_content":"styles_container_content__G0EtZ"};